import React, { useEffect } from 'react'
import { navigate } from 'gatsby'
import Header from './components/Header/index.js'
import LandingHero from './components/LandingHero/index.js'
import LandingHeroHoliday from './components/LandingHeroHoliday/index.js'
import LandingFeatures from './components/LandingFeatures/index.js'
import LandingPartners from './components/LandingPartners/index.js'
import LandingAdvantages from './components/LandingAdvantages/index.js'
import LandingDescription from './components/LandingDescription/index.js'
import LandingServicing from './components/LandingServicing/index.js'
import LandingExpress from './components/LandingExpress/index.js'
import LandingEmail from './components/LandingEmail/index.js'
import LandingFaq from './components/LandingFaq/index.js'
import LandingFooter from './components/LandingFooter/index.js'
import WhatsAppButton from 'components/WhatsAppButton'
import { useContent } from 'modules/Content'
import LandingLayout from '../../layouts/LandingLayout'
import storage from 'utils/storage'

import segment from 'utils/segment'
import GA from 'utils/GA'
import If from 'rv-components/react/If'
import featureToggle from 'utils/featureToggle'
import { addNRPageView } from 'utils/newRelicEvents.js'
const { lpWppButton } = featureToggle()
import './Landing.styl'
import isClient from 'utils/isClient.js'
import analyticsUuid from 'utils/analyticsUuid.js'

const DynamicComponent = ({ blok, location, holiday, overlap }) => {
  let Components = {
    lp_header: Header,
    lp_express: LandingExpress,
    lp_servicing: LandingServicing,
    lp_features: LandingFeatures,
    lp_partners: LandingPartners,
    lp_advantages: LandingAdvantages,
    lp_description: LandingDescription,
    lp_faq: LandingFaq,
    lp_email: LandingEmail,
    lp_footer: LandingFooter,
  }

  if (holiday) {
    Components = { ...Components, lp_hero_holiday: LandingHeroHoliday }
  } else {
    Components = { ...Components, lp_hero: LandingHero }
  }

  // Components = { ...Components, lp_hero: LandingHero }

  const Component = Components[blok.component]

  return Component ? (
    <Component
      blok={blok}
      location={location}
      holiday={holiday}
      overlap={overlap}
    />
  ) : null
}

const Landing = ({ location, pageContext }) => {
  if (location.href === 'https://renegocie.cartoes.itau.com.br/') {
    if (typeof window !== 'undefined') {
      window.onbeforeunload = null
    }
    navigate('/error')
  }

  useEffect(() => {
    analyticsUuid.clearKeepingAnalyticsUuid()

    storage.session.setItem('theme', pageContext?.slug)

    storage.local.setItem('callbackUrl', isClient() && window.location.href)

    storage.session.setItem('keepSession', true)

    GA.addGTM()

    segment.track('pageView', 'lp_home')
    addNRPageView('lp_home')
    GA.pageLoad('lp_home')
  }, [])

  const blok = useContent(`${pageContext?.slug}`, {
    hasTheme: false,
  })

  const content = blok?.body?.map((childBlok) => (
    <DynamicComponent
      blok={childBlok}
      key={childBlok._uid}
      location={location}
      holiday={blok.holiday}
      overlap={blok.overlap_header}
    />
  ))

  return (
    <LandingLayout>
      <If condition={lpWppButton} renderIf={<WhatsAppButton />} />
      <div className="landing-container">{content ? content : null}</div>
    </LandingLayout>
  )
}

export default Landing
